const SITE_ORIGIN = "https://www.newfw.com.cn";

const OG_LOCALE = {
  en: "en_US",
  "zh-CN": "zh_CN",
  "zh-TW": "zh_TW",
};

function upsertMeta(selector, attrs, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([key, value]) => {
      el.setAttribute(key, value);
    });
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function applyDocumentMeta({ title, description, path, locale }) {
  if (title) {
    document.title = title;
    upsertMeta('meta[property="og:title"]', { property: "og:title" }, title);
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title" }, title);
    upsertMeta('meta[itemprop="name"]', { itemprop: "name" }, title);
  }
  if (description) {
    upsertMeta('meta[name="description"]', { name: "description" }, description);
    upsertMeta(
      'meta[property="og:description"]',
      { property: "og:description" },
      description
    );
    upsertMeta(
      'meta[name="twitter:description"]',
      { name: "twitter:description" },
      description
    );
    upsertMeta(
      'meta[itemprop="description"]',
      { itemprop: "description" },
      description
    );
  }
  if (path != null) {
    const url = `${SITE_ORIGIN}${path}`;
    upsertMeta('meta[property="og:url"]', { property: "og:url" }, url);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }
  if (locale) {
    document.documentElement.lang = locale;
    upsertMeta(
      'meta[property="og:locale"]',
      { property: "og:locale" },
      OG_LOCALE[locale] || "en_US"
    );
  }
}
